module.exports = __webpack_public_path__ + "static/media/mode-36.31ef64ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-36.svg
// module id = 991
// module chunks = 2